import { GeneralServiceDocumentType } from '@mews-distributor/data-access';
import { setServiceDocuments } from '../../modules/entities/serviceDocuments/reducer';
import { logSentryError } from '../../sentry/sentry';
import type { DistributorPromiseThunkAction } from '../../types';

interface FetchServiceDocumentsParams {
    serviceIds: string[];
    types: GeneralServiceDocumentType[];
}

export const fetchServiceDocuments =
    ({ serviceIds, types }: FetchServiceDocumentsParams): DistributorPromiseThunkAction =>
    async (dispatch, _getState, { apiService }) => {
        try {
            const { documents } = await apiService.getServiceDocuments({ serviceIds, types });
            dispatch(setServiceDocuments({ serviceDocuments: documents }));
        } catch (error) {
            dispatch(logSentryError({ error, extra: { serviceIds, types } }));
        }
    };
